// extracted by mini-css-extract-plugin
export default {"MilestoneTemplates":"MilestoneTemplates_MilestoneTemplates__4Tmyq","Templates":"MilestoneTemplates_Templates__jenei","NoTaskTemplate":"MilestoneTemplates_NoTaskTemplate__oujDd"};